import { useEffect, useRef } from "react";

import { isAfterTrialEntryModalInDom, reloadToSiAfterTrialHome, shouldReloadAfterTrialModalRemoved } from "../utils";

const DOM_CHECK_INTERVAL_MS = 200;

type UseAfterTrialEntryModalDomGuardParams = {
    isEnabled: boolean;
};

export const useAfterTrialEntryModalDomGuard = ({ isEnabled }: UseAfterTrialEntryModalDomGuardParams): void => {
    const wasModalInDomRef = useRef(false);
    const isReloadingRef = useRef(false);

    useEffect(() => {
        if (!isEnabled) {
            wasModalInDomRef.current = false;
            isReloadingRef.current = false;
            return;
        }

        const checkModalPresence = () => {
            if (isReloadingRef.current) {
                return;
            }

            const isModalInDom = isAfterTrialEntryModalInDom();

            if (isModalInDom) {
                wasModalInDomRef.current = true;
                return;
            }

            if (!shouldReloadAfterTrialModalRemoved(wasModalInDomRef.current, isModalInDom)) {
                return;
            }

            isReloadingRef.current = true;
            reloadToSiAfterTrialHome();
        };

        const intervalId = window.setInterval(checkModalPresence, DOM_CHECK_INTERVAL_MS);
        const mutationObserver = new MutationObserver(checkModalPresence);
        mutationObserver.observe(document.body, { childList: true, subtree: true });

        checkModalPresence();

        return () => {
            window.clearInterval(intervalId);
            mutationObserver.disconnect();
            wasModalInDomRef.current = false;
            isReloadingRef.current = false;
        };
    }, [isEnabled]);
};
